import tinymce from 'tinymce/tinymce'
import 'tinymce/themes/silver'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/link'
import 'tinymce/plugins/image'
import 'tinymce/plugins/media'
import 'tinymce/icons/default'
import 'tinymce/skins/ui/oxide/content.min.css'
import 'tinymce/skins/ui/oxide/skin.min.css'
export default class TextTiny {
  constructor (containerText) {
    if (containerText) {
      tinymce.init({
        selector: '.tinye_text',
        plugins: 'paste image link media',
        forced_root_blocks: false,
        branding: false,
        height: 300,
        paste_as_text: true,
        themes: 'modern',
        content_style: 'body { font-size: 12pt; font-family: sans-serif; }',
        toolbar: [
          'undo redo | styleselect | bold italic | link unlink media'
        ],
        menubar: false,
        resize: false,
        force_br_newlines : true,
        force_p_newlines : false,
        forced_root_block : ''
      })
    }
  }

}
